import React from 'react';

function SmBanner() {
    return (
     <section>
        <div class="w-full bg-darkGray text-white text-sm sm-banner py-2 absolute top-[85px] sm:top-[70pxs] md:top-[65px] z-30 flex items-center justify-center">
            <p class="text-center">
                Obtén hasta el <strong>70%</strong> de <strong>descuento </strong> por temporada navideña
            </p>
        </div>
    </section>
    );
}

export default  SmBanner;